// Mock content data for the ZUBO landing page.
// Trilingual: German (de), English (en), Bosnian/Croatian/Serbian (bks).
// Images extracted from the original document live in /public/images.

export const IMAGES = {
  heroZubo: "/images/hero-zubo.jpg",
  sketchZubo: "/images/sketch-zubo.jpg",
  sketchZahnfee: "/images/sketch-zahnfee.jpg",
  sketchFairy: "/images/sketch-fairy.webp",
  conceptMockup: "/images/concept-mockup.jpg",
  drNeda: "/images/dr-neda-web.png",
  mascotBadge: "/images/mascot-badge-v2.jpg",
  mascotHero: "/images/mascot-hero-v2.jpg",
  bookPhoneArt: "/images/book-phone-art.jpg",
  openbookArt: "/images/openbook-art.jpg",
  tabletArt: "/images/mock-tablet.png",
  calendarArt: "/images/mock-calendar.png",
  groupCharacters: "/images/group-characters.jpg",
  journeyStrip: "/images/journey-strip.jpg",
  charFrida: "/images/char-frida.jpg",
  charZubo: "/images/char-zubo.jpg",
  charZahnfee: "/images/char-zahnfee.jpg",
  charRitterEi: "/images/char-ritter-ei.jpg",
  charSirko: "/images/char-sirko.jpg",
  charApfel: "/images/char-apfel.jpg",
  iconBook: "/images/zubo-icon-book.png",
  iconCalendar: "/images/zubo-icon-calendar.png",
  iconApp: "/images/zubo-icon-app.png",
  iconScan: "/images/zubo-icon-scan.png",
  iconBrush: "/images/zubo-icon-brush.png",
  iconStar: "/images/zubo-icon-star.png",
  iconHeart: "/images/zubo-icon-heart.png",
};

// Feature wishlist options (stable keys used by the backend; labels are localized).
export const FEATURE_OPTIONS = {
  de: [
    { key: "gus_timer", label: "Putz-Timer mit Lied & Audio-Führung" },
    { key: "avatar", label: "Avatar zum Selbstgestalten" },
    { key: "tokens", label: "Belohnungs-Sterne & Sammelsystem" },
    { key: "minigames", label: "Mini-Spiele mit 3 Levels" },
    { key: "calendar", label: "Fortschritts-Kalender für Eltern" },
    { key: "reminders", label: "Sanfte Erinnerungen" },
    { key: "multikid", label: "Mehrere Kinder-Profile" },
    { key: "bilingual", label: "Zweisprachig DE & BKS" },
  ],
  en: [
    { key: "gus_timer", label: "Brushing timer with song & audio guidance" },
    { key: "avatar", label: "Design-your-own avatar" },
    { key: "tokens", label: "Reward stars & collection system" },
    { key: "minigames", label: "Mini-games with 3 levels" },
    { key: "calendar", label: "Progress calendar for parents" },
    { key: "reminders", label: "Gentle reminders" },
    { key: "multikid", label: "Multiple child profiles" },
    { key: "bilingual", label: "Bilingual DE & BKS" },
  ],
  bks: [
    { key: "gus_timer", label: "Tajmer s pjesmom i audio-vođenjem" },
    { key: "avatar", label: "Avatar koji dijete samo kreira" },
    { key: "tokens", label: "Nagradne zvjezdice i sistem sakupljanja" },
    { key: "minigames", label: "Video igrice sa 3 nivoa" },
    { key: "calendar", label: "Kalendar napretka za roditelje" },
    { key: "reminders", label: "Nježni podsjetnici" },
    { key: "multikid", label: "Više dječijih profila" },
    { key: "bilingual", label: "Dvojezično DE i BKS" },
  ],
};

export const translations = {
  de: {
    title: "ZUBO™ — Frida und die Zahnwächter",
    desc: "ZUBO macht Zähneputzen zu einem Abenteuer. Ein Bilderbuch, ein Kalender und bald eine App — entwickelt von einer Kinderzahnärztin aus Salzburg.",
    nav1: "Die Idee", nav2: "So funktioniert's", nav3: "Über uns", navcta: "Jetzt unterstützen",
    heroEyebrow: "Wir bauen ZUBO. Gemeinsam mit euch.",
    heroH1a: "Eine kleine Geschichte. ",
    heroH1accent: "Ein großes Abenteuer.",
    heroH1b: " Ein neues Ritual fürs Zähneputzen.",
    heroLead: "Alles begann mit einer Geschichte und einer einfachen Frage: Was wäre, wenn Zähneputzen für Kinder nichts wäre, das sie müssen — sondern etwas, worauf sie sich freuen? ZUBO verbindet eine liebevolle Geschichte, ein 28-Tage-Ritual und eine zukünftige digitale Welt. ZUBO ist noch nicht fertig — und genau deshalb möchten wir dich von Anfang an dabei haben.",
    heroCta1: "Sei dabei, wenn ZUBO entsteht", heroCta2: "Für den Startnext-Launch vormerken",
    heroNote: "Keine Zahlung jetzt fällig — wir sagen dir Bescheid, sobald die Kampagne live ist.",
    badge1: "✨ Ohne Strafen, nur Lob", badge2: "📖 50 Seiten · DE & BKS",
    sketchEyebrow: "Ein erster Blick",
    sketchH2: "Original-Skizzen von Marica Kicušić",
    sketchP: "Die Illustratorin arbeitet gerade an den Figuren für „Frida und die Zahnwächter“ — hier zwei Blicke direkt aus ihrem Skizzenbuch.",
    sketchCap1: "Zubo, handgezeichnet mit Buntstift",
    sketchCap2: "Die Zahnfee bei der Arbeit",
    sketchCap3: "Die Zahnfee fliegt durch Zubos Welt",
    conceptEyebrow: "Erste Ideen",
    conceptH2: "So könnte ZUBO digital aussehen",
    conceptP: "Die digitale ZUBO-Welt ist noch eine Idee. Wir zeigen dir unsere ersten Konzepte, Figuren und Spielideen — aber noch ist nichts in Stein gemeißelt. Wir wollen nicht einfach etwas für Familien bauen — wir wollen etwas bauen, das Familien wirklich wollen.",
    conceptBadge: "🧪 Konzept-Mockup — noch nicht real",
    whyEyebrow: "Warum ZUBO",
    whyH2: "Kennst du diese Momente?",
    whyP: "„Zähneputzen!“ — „Ich will nicht!“ — „Aber ich hab doch schon!“ Und plötzlich wird aus zwei Minuten eine Diskussion. Zwischen Müdigkeit, Zeitdruck und kleinen Widerständen wird aus einer einfachen Routine schnell ein täglicher Kampf.",
    probH3: "Worum es wirklich geht",
    probLi1: "Es geht nicht nur ums Zähneputzen",
    probLi2: "Es geht darum, wie Kinder Gesundheit erleben",
    probLi3: "Mit Druck — oder mit Neugier, Selbstvertrauen und Freude?",
    solH3: "Wir glauben: Es darf anders gehen",
    solLi1: "Positive Verstärkung statt Druck",
    solLi2: "Neugier und Selbstvertrauen statt Kampf",
    solLi3: "Freude an der eigenen Gesundheit",
    howEyebrow: "Buch → 28 Tage → digitale Welt",
    howH2: "Eine Geschichte, die weitergeht.",
    howP: "Nicht drei einzelne Produkte, sondern eine gemeinsame Reise.",
    step1num: "Schritt 1", step1h: "Das Buch", step1p: "Frida und die Zahnwächter nehmen Kinder mit in eine Welt, in der Zähne echte Helden sind.",
    step2num: "Schritt 2", step2h: "Das 28-Tage-Ritual", step2p: "Aus der Geschichte wird ein kleines gemeinsames Ritual — Tag für Tag.",
    step3num: "Schritt 3", step3h: "ZUBO", step3p: "Die Welt von Frida wird digital weitergeführt — Schritt für Schritt.",
    visionEyebrow: "Was ist ZUBO?",
    visionH2: "Eine Geschichte. Ein Ritual. Eine digitale Abenteuerwelt.",
    visionP: "ZUBO ist eine neue Begleitung für Kinder und Familien rund ums tägliche Zähneputzen — Teil des Autorenprojekts „Frida und die Zahnwächter“ und der „Pädagogik des Lächelns™“. ZUBO verbindet spielerisches Lernen mit echten Alltagsmomenten — damit Kinder nicht nur wissen, warum Zähneputzen wichtig ist, sondern selbst erleben können: „Ich kann das!“",
    eco1h: "Das Bilderbuch",
    eco1p: "„Frida und die Zahnwächter“: 50 Seiten im Premium-Format 20×20 cm. Die Geschichte nimmt Kindern die Angst — und macht sie selbst zu Helden.",
    eco2h: "Der 28-Tage-Kalender",
    eco2p: "Das analoge Ritual im Buch: 28 Tage ausmalen und Sticker kleben — genau so lange braucht ein Kind, um eine neue Gewohnheit aufzubauen.",
    eco3h: "Die ZUBO-App",
    eco3p: "Der digitale Begleiter (in Entwicklung): geführter 2-Minuten-Timer mit Lied, Belohnungs-Sterne und Lern-Minispiele — ganz ohne Strafen.",
    flow1label: "Lesen", flow1text: "Gemeinsam die Geschichte im Buch entdecken.",
    flow2label: "Scannen", flow2text: "QR-Code im Buch scannen und ZUBO-App öffnen.",
    flow3label: "Zähneputzen", flow3text: "Das Zähneputz-Ritual starten und den Timer nutzen.",
    flow4label: "Sammeln", flow4text: "Sterne sammeln und Erfolge feiern.",
    flow5label: "Dranbleiben", flow5text: "Gesunde Gewohnheiten werden zum Alltag.",
    visionBridge: "Jedes Buch enthält einen QR-Code, der die ersten digitalen Ideen freischaltet — so wachsen offline und online zusammen.",
    digiEyebrow: "Erste Ideen",
    digiH2: "Noch gibt es ZUBO nicht — und genau deshalb fragen wir dich zuerst.",
    digiLi1: "Was sollte ZUBO können?",
    digiLi2: "Was würde deinem Kind Freude machen?",
    digiLi3: "Was würde euch im Alltag wirklich helfen?",
    digiLi4: "Deine Meinung entscheidet mit, was wir als Nächstes entwickeln.",
    wasEyebrow: "Das Projekt",
    wasH2: "Was entsteht?",
    wasLi1: "Ein liebevoll illustriertes Bilderbuch",
    wasLi2: "Ein 28-Tage-Gewohnheitskalender mit Stickern",
    wasLi3: "Eine interaktive App (in Entwicklung)",
    wasLi4: "Viele kleine Abenteuer für gesunde Kinderzähne",
    pil1h: "Stärkt Kinder", pil1p: "Spielerisch zu mehr Selbstvertrauen und Selbstwirksamkeit.",
    pil2h: "Entlastet Eltern", pil2p: "Einfache Routinen und Tools, die wirklich helfen.",
    pil3h: "Von Expertin entwickelt", pil3p: "Von einer Kinderzahnärztin mit Herz und Erfahrung.",
    figEyebrow: "Die Figuren",
    figH2: "Wer wohnt in Zahnstadt?",
    figP: "Diese Freunde begleiten die Kinder durch das Buch — und später durch die App.",
    figFrida: "Frida", figFridaRole: "Die Heldin der Geschichte",
    figZubo: "Zubo", figZuboRole: "Bester Freund & Begleiter",
    figZahnfee: "Die Zahnfee", figZahnfeeRole: "Die liebevolle Mentorin",
    figRitterEi: "Ritter Ei", figRitterEiRole: "Der tapfere Ritter",
    figSirko: "Herr Sirko", figSirkoRole: "Der lustige Käse",
    figApfel: "Apfel Knackig", figApfelRole: "Der knackige Apfel",
    aboutEyebrow: "Von einer Zahnärztin für Familien",
    aboutH2: "Warum ich ZUBO entwickle",
    aboutP: "Ich bin Dr. Neda Trivić, Zahnärztin. In meiner Praxis sehe ich jeden Tag Kinder, die schon vor dem ersten Griff nach der Zahnbürste Angst haben — und Eltern, die alles versuchen, aber abends keine Kraft mehr für den nächsten Kampf haben. Genau für diese Familien entsteht ZUBO. Ich möchte, dass Kinder verstehen: Mein Körper gehört mir. Mein Lächeln ist etwas Besonderes. Und ich kann selbst etwas dafür tun.",
    aboutP2: "Das Bilderbuch „Frida und die Zahnwächter“ und die ZUBO-App sind aus meinem Wunsch entstanden, kindliche Angst durch Stolz zu ersetzen und elterliche Erschöpfung durch Entlastung. Als Zahnärztin und als jemand, der die Dynamik des Familienalltags versteht, möchte ich Botschaften senden, die nicht befehlen, sondern inspirieren.",
    aboutQuote: '„ZUBO soll aus einer Pflicht ein kleines Abenteuer machen — mit weniger Druck, mehr Freude und dem Gefühl: Das kann ich!“ — Dr. Neda',
    fundEyebrow: "Bald geht's los",
    fundH2: "Sei beim Start dabei.",
    fundP: "Wir möchten ZUBO gemeinsam mit euch zum Leben erwecken — dafür bereiten wir gerade unsere Startnext-Kampagne vor. Trag dich ein und wir informieren dich, sobald ZUBO auf Startnext startet.",
    fundSlotTitle: "🚀 Kampagne in Vorbereitung",
    fundSlotText: "Hier erscheint bald die Finanzierungsanzeige von Startnext.",
    fundCta: "Startnext-Launch nicht verpassen",
    mitEyebrow: "Deine Meinung zählt",
    ideasBadge: "⭐ Dein erster Schritt: Sag uns, was ZUBO können soll",
    ideasLabel: "Deine eigene Idee (optional)",
    ideasPlaceholder: "Was wünschst du dir für ZUBO? Schreib es hier frei rein …",
    mitH2: "Du entscheidest mit, wie ZUBO wird.",
    mitP: "Es gibt noch keine fertige App — und das ist Absicht. Bevor wir bauen, wollen wir wissen, was für eure Familie wirklich zählt. Deine Auswahl ist kein Fragebogen — sie ist unser Kompass.",
    surveyQ: "Was würde deinem Kind beim Zähneputzen wirklich helfen? (Mehrfachauswahl)",
    preorderLabel: "📖 Ich möchte das Bilderbuch „Frida und die Zahnwächter“ vorbestellen",
    formLabel: "Deine E-Mail-Adresse", formPlaceholder: "deine@email.at", formBtn: "ZUBO mitgestalten",
    fundNote: "Kein Spam. Nur eine Nachricht, wenn die Kampagne startet.",
    waitlistSuccess: "Danke! Deine Antworten wurden gespeichert. Wir melden uns, sobald die Kampagne startet.",
    waitlistError: "Etwas ist schiefgelaufen. Bitte versuche es später erneut.",
    navBook: "Das Buch",
    bookEyebrow: "Das Bilderbuch",
    bookH2: "„Frida und die Zahnwächter“ vorbestellen",
    bookP: "Die Geschichte über Fridas ersten Besuch beim Zahnarzt — 50 liebevoll illustrierte Seiten, die Kindern die Angst nehmen, bevor sie überhaupt entsteht.",
    bookLi1: "Geschrieben von Dr. Neda Trivić",
    bookLi2: "Illustriert von Marica Kicušić",
    bookLi3: "Erhältlich in 2 Sprachen: Deutsch & BKS",
    bookBtn: "Buch unverbindlich vormerken",
    bookNote: "Unverbindlich & kostenlos — keine Zahlung jetzt. Wir melden uns, sobald das Buch bestellbar ist.",
    bookSuccess: "Danke! Dein Buch ist vorgemerkt. Wir melden uns, sobald es bestellbar ist.",
    counter1: "Familie ist schon dabei",
    counterMany: "Familien sind schon dabei",
    snRaised: "finanziert",
    snSupporters: "Unterstützer:innen",
    snOpen: "Zur Kampagne auf Startnext →",
    beliefEyebrow: "Worum es wirklich geht",
    belief1: "Es geht nicht nur ums Zähneputzen.",
    belief2: "Es geht darum, wie Kinder die Pflege ihrer Gesundheit erleben.",
    belief3: "Mit Freude, Neugier und Selbstvertrauen statt mit Druck.",
    beliefEyebrow2: "Wir glauben, es darf anders gehen",
    belief4: "Positive Verstärkung statt Druck",
    belief5: "Neugier und Selbstvertrauen statt Kampf",
    belief6: "Freude an der Pflege der eigenen Gesundheit",
    beliefClose: "ZUBO ist da, um jedem Kind zuzuflüstern: „Dein Lächeln ist etwas Besonderes und du hast die Kraft, es zu schützen.“ So wird die tägliche Zahnpflege zu ihrem ersten eigenständigen Abenteuer.",
    shareTitle: "ZUBO teilen",
    shareText: "Schau dir ZUBO an – ein neues Zahnputz-Ritual für Kinder:",
    shareCopied: "Link kopiert ✓",
    legalImpressum: "Impressum",
    legalPrivacy: "Datenschutz",
    footerP1: "Ein Projekt von Dr. Neda Trivić · Kapitelgasse 9, 5020 Salzburg",
    footerP2: 'Teil des Autorenprojekts „Frida und die Zahnwächter“ & der Pädagogik des Lächelns™',
    footerTag: "Eine Geschichte. Ein Ritual. Ein Abenteuer. Gemeinsam entwickelt.",
  },
  en: {
    title: "ZUBO™ — Frida and the Tooth Guardians",
    desc: "ZUBO turns brushing teeth into an adventure. A picture book, a calendar, and soon an app — developed by a pediatric dentist from Salzburg.",
    nav1: "The Idea", nav2: "How it works", nav3: "About us", navcta: "Support now",
    heroEyebrow: "We're building ZUBO. Together with you.",
    heroH1a: "One little story. ",
    heroH1accent: "One big adventure.",
    heroH1b: " A new way to make toothbrushing part of the day.",
    heroLead: "It all started with a story and a simple question: what if brushing your teeth wasn't something children had to do — but something they actually looked forward to? ZUBO brings together a heartwarming story, a 28-day ritual and a future digital world. ZUBO isn't finished yet — and that's exactly why we want you to be part of creating it.",
    heroCta1: "Be part of creating ZUBO", heroCta2: "Sign up for the Startnext launch",
    heroNote: "No payment due now — we'll let you know as soon as the campaign goes live.",
    badge1: "✨ No punishments, only praise", badge2: "📖 50 pages · DE & BKS",
    sketchEyebrow: "A first look",
    sketchH2: "Original sketches by Marica Kicušić",
    sketchP: "The illustrator is currently working on the characters for “Frida and the Tooth Guardians” — here are two glimpses straight from her sketchbook.",
    sketchCap1: "Zubo, hand-drawn in colored pencil",
    sketchCap2: "The tooth fairy at work",
    sketchCap3: "The tooth fairy flying through Zubo's world",
    conceptEyebrow: "Early ideas",
    conceptH2: "This is what ZUBO could look like, digitally",
    conceptP: "The digital ZUBO world is still an idea. We're sharing our first concepts, characters and game ideas — but nothing is set in stone. We don't simply want to build something for families — we want to build something families truly want.",
    conceptBadge: "🧪 Concept mockup — not real yet",
    whyEyebrow: "Why ZUBO",
    whyH2: "Do you know these moments?",
    whyP: "“Time to brush your teeth!” — “I don't want to!” — “But I already did!” And suddenly, two minutes turn into a daily negotiation. Between tiredness, busy evenings and little resistances, a simple routine can quickly become a daily struggle.",
    probH3: "What it's really about",
    probLi1: "It isn't only about brushing teeth",
    probLi2: "It's about how children experience taking care of their health",
    probLi3: "Through pressure — or through curiosity, confidence and play?",
    solH3: "We believe there's another way",
    solLi1: "Positive reinforcement instead of pressure",
    solLi2: "Curiosity and confidence instead of a fight",
    solLi3: "Joy in caring for their own health",
    howEyebrow: "Book → 28 days → digital world",
    howH2: "A story that keeps going.",
    howP: "Not as three separate products, but as one shared journey.",
    step1num: "Step 1", step1h: "The book", step1p: "Frida and the Tooth Guardians open the door to a world where teeth become little heroes.",
    step2num: "Step 2", step2h: "The 28-day ritual", step2p: "The story becomes a small shared daily ritual — one day at a time.",
    step3num: "Step 3", step3h: "ZUBO", step3p: "The world of the story continues digitally — step by step.",
    visionEyebrow: "What is ZUBO?",
    visionH2: "A story. A ritual. A digital adventure world.",
    visionP: "ZUBO is a new way to support children and families through the everyday routine of brushing teeth — part of the author project “Frida and the Tooth Guardians” and the “Pedagogy of the Smile™”. ZUBO connects play, storytelling and learning with real everyday moments — so children don't just understand why brushing matters, but begin to feel: “I can do this!”",
    eco1h: "The picture book",
    eco1p: "“Frida and the Tooth Guardians”: 50 pages in a premium 20×20 cm format. The story takes away children's fear — and makes them the heroes.",
    eco2h: "The 28-day calendar",
    eco2p: "The analog ritual inside the book: 28 days of coloring and stickers — exactly how long a child needs to build a new habit.",
    eco3h: "The ZUBO app",
    eco3p: "The digital companion (in development): a guided 2-minute timer with a song, reward stars and educational mini-games — with no punishments at all.",
    flow1label: "Read", flow1text: "Discover the story together in the book.",
    flow2label: "Scan", flow2text: "Scan the QR code in the book and open the ZUBO app.",
    flow3label: "Brush", flow3text: "Start the brushing ritual and use the timer.",
    flow4label: "Collect", flow4text: "Collect stars and celebrate successes.",
    flow5label: "Keep going", flow5text: "Healthy habits become part of everyday life.",
    visionBridge: "Every book will include a QR code unlocking the first digital experiences — offline and online become connected.",
    digiEyebrow: "Early ideas",
    digiH2: "ZUBO doesn't exist as a finished app yet — and that's exactly why we're asking you first.",
    digiLi1: "What should ZUBO do?",
    digiLi2: "What would make your child excited?",
    digiLi3: "What would genuinely help your family in everyday life?",
    digiLi4: "Your answers help shape what we build next.",
    wasEyebrow: "The project",
    wasH2: "What we're creating",
    wasLi1: "A lovingly illustrated picture book",
    wasLi2: "A 28-day habit calendar with stickers",
    wasLi3: "An interactive app (in development)",
    wasLi4: "Lots of little adventures for healthy kids' teeth",
    pil1h: "Empowers kids", pil1p: "Playfully builds confidence and self-efficacy.",
    pil2h: "Relieves parents", pil2p: "Simple routines and tools that really help.",
    pil3h: "Developed by an expert", pil3p: "Created by a pediatric dentist with heart and experience.",
    figEyebrow: "The characters",
    figH2: "Who lives in Tooth Town?",
    figP: "These friends accompany children through the book — and later through the app.",
    figFrida: "Frida", figFridaRole: "The hero of the story",
    figZubo: "Zubo", figZuboRole: "Best friend & companion",
    figZahnfee: "The Tooth Fairy", figZahnfeeRole: "The loving mentor",
    figRitterEi: "Knight Egg", figRitterEiRole: "The brave knight",
    figSirko: "Mr. Sirko", figSirkoRole: "The funny cheese",
    figApfel: "Crunchy Apple", figApfelRole: "The crunchy apple",
    aboutEyebrow: "By a dentist, for families",
    aboutH2: "Why am I creating ZUBO?",
    aboutP: "I'm Dr. Neda Trivić, a dentist. Every day in my practice, I meet children who are already afraid before they even reach for their toothbrush — and parents who try everything but simply don't have the energy for another battle at the end of the day. ZUBO is being created for exactly these families. I want children to feel: My body is mine. My smile is something special. And I can take care of my own health.",
    aboutP2: "The picture book “Frida and the Tooth Guardians” and the ZUBO app grew out of my wish to replace children's fear with pride, and parents' exhaustion with relief. As a dentist and someone who understands the dynamics of everyday family life, I want to send messages that don't command, but inspire.",
    aboutQuote: '"ZUBO aims to turn a daily obligation into a little adventure — less pressure, more joy, and the feeling: I can do this!" — Dr. Neda',
    fundEyebrow: "Coming soon",
    fundH2: "Be there from the beginning.",
    fundP: "We want to bring ZUBO to life together with you — that's why we're currently preparing our Startnext campaign. Leave your email and we'll let you know when ZUBO launches on Startnext.",
    fundSlotTitle: "🚀 Campaign in preparation",
    fundSlotText: "The Startnext funding tracker will appear here soon.",
    fundCta: "Don't miss the Startnext launch",
    mitEyebrow: "Your opinion counts",
    ideasBadge: "⭐ Your first step: tell us what ZUBO should do",
    ideasLabel: "Your own idea (optional)",
    ideasPlaceholder: "What would you like ZUBO to have? Write freely here …",
    mitH2: "You decide what ZUBO becomes.",
    mitP: "There is no finished app yet — and that's intentional. Before we start building, we want to know what really matters to your family. This isn't just a survey — your answers are our compass.",
    surveyQ: "What would help your child most when brushing their teeth? (select multiple)",
    preorderLabel: "📖 I'd like to pre-order the picture book “Frida and the Tooth Guardians”",
    formLabel: "Your email address", formPlaceholder: "you@example.com", formBtn: "Help shape ZUBO",
    fundNote: "No spam. Just one message when the campaign starts.",
    waitlistSuccess: "Thank you! Your answers have been saved. We'll reach out as soon as the campaign starts.",
    waitlistError: "Something went wrong. Please try again later.",
    navBook: "The book",
    bookEyebrow: "The picture book",
    bookH2: "Pre-order “Frida and the Tooth Guardians”",
    bookP: "The story of Frida's first visit to the dentist — 50 lovingly illustrated pages that take away children's fear before it even begins.",
    bookLi1: "Written by Dr. Neda Trivić",
    bookLi2: "Illustrated by Marica Kicušić",
    bookLi3: "Available in 2 languages: German & BKS",
    bookBtn: "Reserve my copy",
    bookNote: "Free & non-binding — no payment now. We'll reach out as soon as the book can be ordered.",
    bookSuccess: "Thank you! Your copy is reserved. We'll reach out as soon as it can be ordered.",
    counter1: "family has already joined",
    counterMany: "families have already joined",
    snRaised: "raised",
    snSupporters: "supporters",
    snOpen: "View the campaign on Startnext →",
    beliefEyebrow: "What it's really about",
    belief1: "It's not just about brushing teeth.",
    belief2: "It's about how children experience taking care of their health.",
    belief3: "With joy, curiosity and confidence instead of pressure.",
    beliefEyebrow2: "We believe it can be different",
    belief4: "Positive reinforcement instead of pressure",
    belief5: "Curiosity and confidence instead of struggle",
    belief6: "Joy in caring for their own health",
    beliefClose: "ZUBO is here to whisper to every child: “Your smile is something special, and you have the power to protect it.” That's how daily dental care becomes their first independent adventure.",
    shareTitle: "Share ZUBO",
    shareText: "Check out ZUBO – a new tooth-brushing ritual for kids:",
    shareCopied: "Link copied ✓",
    legalImpressum: "Imprint",
    legalPrivacy: "Privacy",
    footerP1: "A project by Dr. Neda Trivić · Kapitelgasse 9, 5020 Salzburg",
    footerP2: 'Part of the author project "Frida and the Tooth Guardians" & the Pedagogy of the Smile™',
    footerTag: "One story. One ritual. One adventure. Developed together.",
  },
  bks: {
    title: "ZUBO™ — Frida i čuvari zubića",
    desc: "ZUBO pretvara pranje zuba u avanturu. Slikovnica, kalendar i uskoro aplikacija — razvila ih je dječija zubarica iz Salzburga.",
    nav1: "Ideja", nav2: "Kako funkcioniše", nav3: "O nama", navcta: "Podrži sada",
    heroEyebrow: "Gradimo ZUBU. Zajedno sa vama.",
    heroH1a: "Mala priča. ",
    heroH1accent: "Velika avantura.",
    heroH1b: " Novi ritual pranja zuba.",
    heroLead: "Sve je počelo jednom pričom i jednom idejom: šta ako pranje zuba djeci ne bi bilo nešto što moraju — nego nešto čemu se raduju? ZUBO spaja nježnu priču, 28-dnevni ritual i budući digitalni svijet u kojem pranje zuba postaje mala svakodnevna avantura. I upravo zato želimo da budeš dio njegovog nastanka.",
    heroCta1: "Budi uz ZUBU", heroCta2: "Prijavi se za Startnext početak",
    heroNote: "Nema plaćanja sada — javićemo ti se čim kampanja krene.",
    badge1: "✨ Bez kazni, samo pohvale", badge2: "📖 50 stranica · njem. i BKS",
    sketchEyebrow: "Prvi pogled",
    sketchH2: "Originalne skice Marice Kicušić",
    sketchP: "Ilustratorica trenutno radi na likovima za „Frida i čuvari zubića“ — evo dva pogleda direktno u njen blok za skiciranje.",
    sketchCap1: "Zubo, nacrtan rukom u boji",
    sketchCap2: "Zubić vila na poslu",
    sketchCap3: "Zubić-vila leti kroz Zubov svijet",
    conceptEyebrow: "Prve ideje",
    conceptH2: "Ovako bi ZUBO mogao izgledati digitalno",
    conceptP: "Digitalni ZUBO svijet još je ideja. Pokazujemo ti prve koncepte, likove i ideje za igru — ali ništa još nije konačno. Želimo napraviti nešto što porodice zaista žele.",
    conceptBadge: "🧪 Konceptualni mockup — još nije stvaran",
    whyEyebrow: "Zašto ZUBO",
    whyH2: "Poznaješ li ove trenutke?",
    whyP: "„Vrijeme je za pranje zuba!“ — „Neću!“ — „Ali već sam oprao/la!“ I odjednom dvije minute postanu svakodnevna rasprava. Između umora, žurbe i dječjeg otpora, jednostavna rutina lako postane mala svakodnevna borba.",
    probH3: "O čemu se zapravo radi",
    probLi1: "Ne radi se samo o pranju zuba",
    probLi2: "Radi se o tome kako djeca doživljavaju brigu o svom zdravlju",
    probLi3: "Kroz pritisak — ili kroz radoznalost, samopouzdanje i igru?",
    solH3: "Mi vjerujemo da može drugačije",
    solLi1: "Pozitivno potkrepljenje umjesto pritiska",
    solLi2: "Radoznalost i samopouzdanje umjesto borbe",
    solLi3: "Radost brige o vlastitom zdravlju",
    howEyebrow: "Knjiga → 28 dana → digitalni svijet",
    howH2: "Priča koja se nastavlja.",
    howP: "Ne kao tri odvojena proizvoda, nego kao jedno zajedničko putovanje.",
    step1num: "Korak 1", step1h: "Knjiga", step1p: "Priča o Fridi i čuvarima zubića otvara vrata svijetu u kojem zubi postaju mali heroji.",
    step2num: "Korak 2", step2h: "28-dnevni ritual", step2p: "Priča se pretvara u mali zajednički ritual — dan po dan.",
    step3num: "Korak 3", step3h: "ZUBO", step3p: "Svijet priče nastavlja se u digitalnom obliku — korak po korak.",
    visionEyebrow: "Šta je ZUBO?",
    visionH2: "Priča. Ritual. Digitalni svijet avanture.",
    visionP: "ZUBO je nova podrška djeci i roditeljima u svakodnevnom pranju zuba — dio autorskog projekta „Frida i čuvari zubića“ i „Pedagogije osmijeha™“. ZUBO povezuje igru, priču i učenje sa stvarnim svakodnevnim trenucima — kako bi djeca ne samo razumjela zašto je pranje zuba važno, nego osjetila: „Ja to mogu!“",
    eco1h: "Slikovnica",
    eco1p: "„Frida i čuvari zubića“: 50 stranica u premium formatu 20×20 cm. Priča djeci oduzima strah — i čini ih herojima.",
    eco2h: "Kalendar od 28 dana",
    eco2p: "Analogni ritual u knjizi: 28 dana bojenja i lijepljenja naljepnica — tačno koliko je djetetu potrebno da izgradi novu naviku.",
    eco3h: "ZUBO aplikacija",
    eco3p: "Digitalni pratilac (u razvoju): vođeni tajmer od 2 minute s pjesmom, nagradne zvjezdice i edukativne mini-igre — potpuno bez kazni.",
    flow1label: "Čitanje", flow1text: "Zajedno otkrijte priču u knjizi.",
    flow2label: "Skeniranje", flow2text: "Skeniraj QR kod u knjizi i otvori ZUBO aplikaciju.",
    flow3label: "Pranje zuba", flow3text: "Pokreni ritual pranja zuba i koristi tajmer.",
    flow4label: "Sakupljanje", flow4text: "Sakupljaj zvjezdice i slavi uspjehe.",
    flow5label: "Istrajnost", flow5text: "Zdrave navike postaju svakodnevica.",
    visionBridge: "Svaka knjiga sadržavat će QR kod koji otvara prve digitalne sadržaje — tako se analogni i digitalni svijet povezuju.",
    digiEyebrow: "Prve ideje",
    digiH2: "ZUBO je u fazi razvoja — i upravo zato pitamo tebe.",
    digiLi1: "Šta bi ZUBO trebao nuditi?",
    digiLi2: "Šta bi tvom djetetu bilo zabavno?",
    digiLi3: "Šta bi vam zaista pomoglo u svakodnevnom životu?",
    digiLi4: "Tvoj odgovor pomaže odlučiti šta ćemo sljedeće razvijati.",
    wasEyebrow: "Projekat",
    wasH2: "Šta nastaje?",
    wasLi1: "Brižljivo ilustrovana slikovnica",
    wasLi2: "Kalendar navika od 28 dana sa naljepnicama",
    wasLi3: "Interaktivna aplikacija (u razvoju)",
    wasLi4: "Mnogo malih avantura za zdrave dječije zube",
    pil1h: "Osnažuje djecu", pil1p: "Kroz igru do samopouzdanja i samostalnosti.",
    pil2h: "Rasterećuje roditelje", pil2p: "Jednostavne rutine i alati koji zaista pomažu.",
    pil3h: "Razvila stručnjakinja", pil3p: "Kreirala dječija zubarica sa srcem i iskustvom.",
    figEyebrow: "Likovi",
    figH2: "Ko živi u Zubogradu?",
    figP: "Ovi prijatelji prate djecu kroz knjigu — a kasnije i kroz aplikaciju.",
    figFrida: "Frida", figFridaRole: "Junakinja priče",
    figZubo: "Zubo", figZuboRole: "Najbolji prijatelj i pratilac",
    figZahnfee: "Zubić vila", figZahnfeeRole: "Brižna mentorica",
    figRitterEi: "Vitez Jaje", figRitterEiRole: "Hrabri vitez",
    figSirko: "Gospodin Sirko", figSirkoRole: "Veseli sir",
    figApfel: "Hrskava Jabuka", figApfelRole: "Hrskava jabuka",
    aboutEyebrow: "Od zubarice porodicama",
    aboutH2: "Zašto stvaram ZUBO?",
    aboutP: "Ja sam dr. Neda Trivić, stomatologinja. U svojoj ordinaciji svakodnevno susrećem djecu koja se boje zubara, a nerado peru zube — i roditelje koji pokušavaju sve, ali navečer jednostavno više nemaju snage za još jednu raspravu. Upravo za takve porodice nastaje ZUBO. Želim da djeca osjete: Moje tijelo pripada meni. Moj osmijeh je nešto posebno. I ja mogu učiniti nešto za svoje zdravlje.",
    aboutP2: "Slikovnica „Frida i čuvari zubića“ i aplikacija ZUBO nastale su iz moje želje da dječji strah zamijenim ponosom, a roditeljski umor — olakšanjem. Kao dr. stomatologije i neko ko razumije dinamiku porodične svakodnevice, želim slati poruke koje ne naređuju, već inspiriraju.",
    aboutQuote: '„ZUBO želi pretvoriti obavezu u malu avanturu — sa manje pritiska, više radosti i osjećajem: Ja to mogu!“ — dr. Neda',
    fundEyebrow: "Uskoro počinjemo",
    fundH2: "Budi s nama od početka.",
    fundP: "Želimo zajedno s vama oživjeti ZUBU — zato trenutno pripremamo našu Startnext kampanju. Ostavi svoj email i javit ćemo ti kada ZUBO krene na Startnext-u.",
    fundSlotTitle: "🚀 Kampanja se priprema",
    fundSlotText: "Ovdje će uskoro biti prikaz napretka finansiranja sa Startnext-a.",
    fundCta: "Ne propusti Startnext početak",
    mitEyebrow: "Tvoje mišljenje je bitno",
    ideasBadge: "⭐ Tvoj prvi korak: reci nam šta ZUBO treba da nudi",
    ideasLabel: "Tvoja ideja (opcionalno)",
    ideasPlaceholder: "Šta bi voljela/volio da ZUBO ima? Napiši slobodno ovdje …",
    mitH2: "Ti odlučuješ kakav će ZUBO postati.",
    mitP: "Aplikacija je još u povojima — i to je namjerno. Prije nego što počnemo graditi, želimo čuti šta je vašoj porodici zaista važno. Ovo nije samo anketa — tvoj odgovor je naš kompas.",
    surveyQ: "Šta bi tvom djetetu najviše pomoglo pri pranju zuba? (višestruki izbor)",
    preorderLabel: "📖 Želim pretplatiti slikovnicu „Frida i čuvari zubića“",
    formLabel: "Tvoja email adresa", formPlaceholder: "tvoja@email.com", formBtn: "Želim pomoći oblikovati ZUBU",
    fundNote: "Bez spama. Samo jedna poruka kad kampanja krene.",
    waitlistSuccess: "Hvala! Tvoji odgovori su sačuvani. Javićemo ti se čim kampanja krene.",
    waitlistError: "Nešto je pošlo po zlu. Pokušaj ponovo kasnije.",
    navBook: "Slikovnica",
    bookEyebrow: "Slikovnica",
    bookH2: "Registruj se za „Frida i čuvari zubića“",
    bookP: "Priča o Fridinoj prvoj posjeti zubaru — 50 brižljivo ilustrovanih stranica koje djeci oduzimaju strah prije nego što uopšte nastane.",
    bookLi1: "Napisala Neda Trivić, dr. stomatologije",
    bookLi2: "Ilustrovala Marica Kicušić",
    bookLi3: "Dostupno na 2 jezika: njemački i BKS",
    bookBtn: "Rezerviši knjigu",
    bookNote: "Besplatno i bez obaveze — nema plaćanja sada. Javićemo ti se čim knjiga bude dostupna za narudžbu.",
    bookSuccess: "Hvala! Tvoja knjiga je predbilježena. Javićemo ti se čim bude dostupna za narudžbu.",
    counter1: "porodica je već uz ZUBO",
    counter234: "porodice su već uz ZUBO",
    counterMany: "porodica je već uz ZUBO",
    snRaised: "prikupljeno",
    snSupporters: "podržavalaca",
    snOpen: "Pogledaj kampanju na Startnext-u →",
    beliefEyebrow: "O čemu se zapravo radi",
    belief1: "Ne radi se samo o pranju zuba.",
    belief2: "Radi se o tome kako djeca doživljavaju brigu o svom zdravlju.",
    belief3: "Sa radošću, znatiželjom i samopouzdanjem umjesto pod pritiskom.",
    beliefEyebrow2: "Vjerujemo da može drugačije",
    belief4: "Pozitivno ohrabrenje umjesto pritiska",
    belief5: "Znatiželja i samopouzdanje umjesto borbe",
    belief6: "Radost u brizi o vlastitom zdravlju",
    beliefClose: "ZUBO je tu da svakom djetetu šapne: „Tvoj osmijeh je poseban i ti imaš moć da ga čuvaš.“ Tako svakodnevna higijena zuba postaje njihova prva samostalna avantura.",
    shareTitle: "Podijeli ZUBU",
    shareText: "Pogledaj ZUBU – novi ritual pranja zuba za djecu:",
    shareCopied: "Link kopiran ✓",
    legalImpressum: "Impresum",
    legalPrivacy: "Privatnost",
    footerP1: "Projekat dr. Nede Trivić · Kapitelgasse 9, 5020 Salzburg",
    footerP2: 'Dio autorskog projekta „Frida i čuvari zubića“ i Pedagogije osmijeha™',
    footerTag: "Jedna priča. Jedan ritual. Jedna avantura. Zajednički razvijeno.",
  },
};

export const LANG_LABELS = { de: "DE", en: "EN", bks: "BKS" };
